import Router from 'root/router';
import View from 'view/base';

export default View.extend({
    onPageReady: function() {
        var update_type = Router.getQueryString('s');
        Router.navigate('/project/?upgrade=' + (update_type || 1), {trigger: true});
    },

    render: function() {
        return this;
    }
});